import { render, staticRenderFns } from "./addCourse.vue?vue&type=template&id=664b950d&scoped=true"
import script from "./addCourse.vue?vue&type=script&lang=js"
export * from "./addCourse.vue?vue&type=script&lang=js"
import style0 from "./addCourse.vue?vue&type=style&index=0&id=664b950d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b950d",
  null
  
)

export default component.exports